<template>
    <div class="box">
        <inner-table id="innerCertificate" ref="certificateList" :listviewurl="'rsgl.archiveCertificatesInfo.list'" :can-edit="canEdit" :can-delete="canEdit" :link-prop-name="'archivesId'" />
    </div>
</template>

<script>
const moment = require('moment')
export default {
    components: {
    },
    props: {
        vo: { type: Object, default: function() { return {} } },
        canEdit: { type: Number, default: 0 }
    },
    data() {
        return {
        }
    },
    computed: {},
    watch: {
    },
    created: function() {
    },
    mounted: function() {
    },
    methods: {
        onInnerTableListDataLoaded($scope, pageInfo) {
            pageInfo.list.forEach(v => {
                v.certificatesDate = v.certificatesDate ? moment(v.certificatesDate).format('YYYY-MM-DD') : ''
                v.expiredDate = v.expiredDate ? moment(v.expiredDate).format('YYYY-MM-DD') : ''
            })
        }
    }
}
</script>

<style scoped>
.header {
    padding:10px 20px;
    background-color: #f2f5fb;
    font-size: 14px;
    font-weight: 500;
}
.box {
   border:1px solid #dee2e6;
}
</style>

